module.exports = __webpack_public_path__ + "img/partner02.b9531695.png";